import apiClient from "../../axios/apiClient";
import { getDateTimeMysqlGivenFormatYmd } from "../../util/generalUtills";

export const getHydrantList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HYDRANTLIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/hydrants`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_HYDRANTLIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_HYDRANTLIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveHydrantData = (token, data) => async (dispatch) => {
    try {
      dispatch({ type: "ADD_HYDRANT_PENDING" });
  
      const response = await apiClient.post(
        `/api/v1/hydrants`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_HYDRANT_FULFILLED", payload: response.data });
    } catch (error) {
      dispatch({ type: "ADD_HYDRANT_REJECTED", payload: error.response });
    }
  };
  

  export const getHydrantListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HYDRANTLISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/hydrants/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_HYDRANTLISTBYID_FULFILLED",
        payload: response.data?.data,
        vehicleCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_HYDRANTLISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateHydrantData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_HYDRANT_PENDING" });

    const response = await apiClient.put(
      `/api/v1/hydrants/${id}`, // Endpoint URL with HYDRANT ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_HYDRANT_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_HYDRANT_REJECTED", payload: error.response });
  }
};

export const updateHydrantStatusData = (token, id, status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_HYDRANT_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/v1/Update-Hydrant-Status/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_HYDRANT_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_HYDRANT_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteHydrantData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_HYDRANT_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/hydrants/${id}`, // Endpoint URL with HYDRANT ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_HYDRANT_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_HYDRANT_REJECTED", payload: error.response });
  }
};


export const getHydrantLiveList =
  (token, limit = 10, page = 1, search = "", sort = "desc",hydrantId, duration,selectedDate=new Date()) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_HYDRANTLIST_PENDING" });

      const response = await apiClient.get(
        `/api/v1/hydrant-valve-live-status`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
            hydrantId:hydrantId,
            duration:duration,
            data_date:getDateTimeMysqlGivenFormatYmd(selectedDate)
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_HYDRANTLIST_FULFILLED",
        payload: response.data?.data || [],
        hydrantStatusList: response.data?.hydrantStatusList || [],
        count: response.data?.pagination?.total,
        summary: response.data?.summary,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      dispatch({
        type: "GET_HYDRANTLIST_REJECTED",
        payload: error.response,
      });
    }
  };
